import { Button, DatePicker, Drawer, Form, Input, message, Radio } from 'antd';
import React, { useEffect } from 'react';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { CalendarService } from 'services/CalendarService';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import dayjs from 'dayjs';

function HandbookCalendarForm({ isActive, onClose, onSuccess, initialValues }) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const {
        date,
        description,
        description_kz,
        holiday,
        name,
        need_to_mobile,
        public_holiday,
        remark,
        work_day_5,
        work_day_6,
      } = initialValues;

      form.setFieldsValue({
        name,
        date: dayjs(date),
        description,
        description_kz,
        holiday,
        need_to_mobile,
        public_holiday,
        remark,
        work_day_5,
        work_day_6,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    const payload = {
      ...values,
      date: values?.date.format('YYYY-MM-DD'),
    };

    if (isEditing) {
      handleUpdate(payload, initialValues?.id);
    } else {
      handleCreate(payload);
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isCreated = await CalendarService.createCalendar(data);

      if (isCreated) {
        handleConfirm();
        message.success(SUCCESS_CREATE);
      }
    } catch (err) {
      message.error(CREATE_ERROR);
    } finally {
      hide();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING, 0);

    try {
      const isUpdated = await CalendarService.updateCalendar(data, id);

      if (isUpdated) {
        handleConfirm();
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  const handleConfirm = () => {
    onClose();
    onSuccess();
    form.resetFields();
  };

  return (
    <Drawer
      title={
        isEditing ? 'Редактирование даты календаря' : 'Создание даты календаря'
      }
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="date" label="Дата" rules={[requiredRule]}>
          <DatePicker format="DD.MM.YYYY" style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name="name" label="Наименование" rules={[requiredRule]}>
          <Input placeholder="Наименование" allowClear />
        </Form.Item>

        <Form.Item name="description" label="Описание" rules={[requiredRule]}>
          <Input placeholder="Описание" allowClear />
        </Form.Item>

        <Form.Item name="description_kz" label="Описание (каз.)">
          <Input placeholder="Описание на казахском" allowClear />
        </Form.Item>

        <Form.Item
          name="public_holiday"
          label="Гос. праздник"
          rules={[requiredRule]}
        >
          <Radio.Group>
            <Radio value>Да</Radio>
            <Radio value={false}>Нет</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item name="holiday" label="Выходной" rules={[requiredRule]}>
          <Radio.Group>
            <Radio value>Да</Radio>
            <Radio value={false}>Нет</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="work_day_5"
          label="Рабочий день 5"
          rules={[requiredRule]}
        >
          <Radio.Group>
            <Radio value>Да</Radio>
            <Radio value={false}>Нет</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="work_day_6"
          label="Рабочий день 6"
          rules={[requiredRule]}
        >
          <Radio.Group>
            <Radio value>Да</Radio>
            <Radio value={false}>Нет</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item name="remark" label="Пометка" rules={[requiredRule]}>
          <Radio.Group>
            <Radio value>Да</Radio>
            <Radio value={false}>Нет</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="need_to_mobile"
          label="Отображать в моб"
          rules={[requiredRule]}
        >
          <Radio.Group>
            <Radio value>Да</Radio>
            <Radio value={false}>Нет</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { HandbookCalendarForm };
